Vue.config.productionTip = false;
Vue.component('currency-input', function (resolve, reject) {
    axios.get(getUrl('content/vuetemplates/currencyinput.html'))
        .then(function (res) {
            resolve({
                inheritAttrs: false,
                template: res.data,
                props: {
                    value: {
                        type: [String, Number]
                    },
                    label: {
                        type: String
                    }
                },
                mounted: function () {
                    this.$refs.input.value = formatPrice(this.$refs.input.value);
                },
                methods: {
                    formatValue: function () {
                        this.$refs.input.value = formatPrice(this.$refs.input.value);
                        this.$emit('input', this.$refs.input.value);
                    }
                }
            });
        })
        .catch(function () { reject(); });
});

window.onload = function () {

    // model
    var viewModel = getSearchViewModelCopy();

    var vm = new Vue({
        el: '.search-aside',
        data: {
            criteria: viewModel.searchCriteria,
            tags: viewModel.searchTags,
            ages: viewModel.ageFilter,
            isBusy: false,
            count: viewModel.listingsCount,
            url: viewModel.url,
            isDiscoverable: viewModel.isDiscoverable
        },

        methods: {
            onDeselectParent: function (tag) {
                if (tag.Children.length > 0 && this.criteria.TagIds.indexOf(tag.Id) >= 0) {
                    for (var i = 0; i < tag.Children.length; i++) {
                        var index = this.criteria.TagIds.indexOf(tag.Children[i].Id);
                        if (index >= 0) {
                            this.criteria.TagIds.splice(index, 1);
                        }
                    }
                }
            },
            resetAndQuit: function () {
                var copy = getSearchViewModelCopy();
                this.criteria = copy.searchCriteria;
                this.isBusy = false;
                this.count = copy.listingsCount;
                this.url = copy.url;
                this.isDiscoverable = copy.isDiscoverable;
                $('.search-aside').hide();
                window.history.back();
            },
            getQueryString: function (obj) {
                var params = [];
                var exclude = ['Price', 'Profit', 'Turnover'];
                var keys = Object.keys(obj);
                for (var i = 0; i < keys.length; i++) {
                    var k = keys[i];
                    // #6453 Always remove the page number so mobile filter updates start on page 1.
                    if (k === 'Page') {
                        continue;
                    }
                    var v = obj[k];
                    if (v !== null) {
                        if (_.isArray(v)) {
                            for (var vi = 0; vi < v.length; vi++)
                                params.push(k + '=' + v[vi]);
                        }
                        else if (_.isObject(v)) {
                            if (exclude.indexOf(k) >= 0) {
                                if (v.From !== null)
                                    params.push(k + '.From' + '=' + v.From);
                                if (v.To !== null)
                                    params.push(k + '.To' + '=' + v.To);
                            }
                        }
                        else {
                            params.push(k + '=' + v);
                        }
                    }
                }
                return params.length > 0 ? '?' + params.join('&') : '';
            }
        },

        mounted: function () {
        },

        computed: {
            industryTags: function () {
                return _.filter(this.tags, function (x) { return x.IsIndustry; });
            },
            propertyTags: function () {
                return _.filter(this.tags, function (x) { return x.IsProperty; });
            },
            managementTags: function () {
                return _.filter(this.tags, function (x) { return x.IsManagement; });
            },
            otherTags: function () {
                return _.filter(this.tags, function (x) { return x.IsOther; });
            },
            parentManagementTag: function () {
                return _.filter(this.tags, function (x) { return x.Name === "Management Type"; })[0];
            }
        },

        watch: {
            criteria: {
                handler: function (val, old) {
                    const hasSelectedChild = this.managementTags.some(tag => val.TagIds.includes(tag.Id));

                    const newCriteria = { ...val };

                    // Add or remove the parent tag ID dynamically
                    if (hasSelectedChild && !newCriteria.TagIds.includes(this.parentManagementTag.Id)) {
                        newCriteria.TagIds.push(this.parentManagementTag.Id);
                    } else if (!hasSelectedChild && newCriteria.TagIds.includes(this.parentManagementTag.Id)) {
                        newCriteria.TagIds = newCriteria.TagIds.filter(id => id !== this.parentManagementTag.Id);
                    }

                    var url = getCobrandedUrl('search/getfiltercounts') + this.getQueryString(newCriteria);

                    axios.get(url)
                        .then(function (r) {
                        var data = r.data;

                        // set count
                        this.count = data.listingsCount;

                        this.url = data.url;
                        this.isDiscoverable = data.isDiscoverable;

                        // set tag counts
                        for (var i = 0; i < this.tags.length; i++) {
                            this.tags[i].Count = data.tagCounts[this.tags[i].Id];
                            if (this.tags[i].Children.length > 0) {
                                for (var ci = 0; ci < this.tags[i].Children.length; ci++) {
                                    this.tags[i].Children[ci].Count = data.tagCounts[this.tags[i].Children[ci].Id];
                                }
                            }
                        }

                        // set age filter count
                        for (var ai = 0; ai < this.ages.length; ai++) {
                            this.ages[ai].Count = this.ages[ai].Value !== null ? data.dateCounts[this.ages[ai].Value] : data.dateCounts[0];
                        }

                    }.bind(this)).catch(function(e) {
                       console.log(e);
                    }.bind(this));
                },
                deep: true
            }
        }
    });
};